import type { FunctionComponent } from "react";
import { useEffect, useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { getChosenPageItems } from "app/components/compare/WebsiteQueryBar/WebsitePageQueryBarUtils";
import { CompareTabs } from "app/components/compareTabs/compareTabs";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { ICompareTabs, Imeta } from "./CompareTabsContainer";
import { useCompareDataQuery } from "./useCompareDataQuery";

export const PageCompareTabsContainer: FunctionComponent<ICompareTabs> = (props) => {
    const {
        api,
        keyName,
        onSelectSite,
        domainQueryParamName,
        queryParamsForCompareTabs,
        hideResults = false,
        requestBody,
    } = props;
    const { params } = useCurrentStateAndParams();

    const pages = getChosenPageItems(JSON.parse(params.pageFilter));
    const page: string = params[domainQueryParamName] ? params[domainQueryParamName] : pages[0].url;

    const [selectedTab, setSelectedTab] = useState(0);
    const [selectedSiteDomain, setSelectedSiteDomain] = useState(page);

    const displayResults = !hideResults && !!api && !!queryParamsForCompareTabs;
    const { data: compareData, isLoading } = useCompareDataQuery({
        api,
        queryParamsForCompareTabs,
        requestBody,
        enabled: displayResults,
    });

    const isDomainSelected = () => pages.some((site) => site.url === page);

    const tabs: Imeta[] = pages.map((domain, index) => {
        return {
            id: `${domain.url}_${index}`,
            title: domain.url,
            reverseEllipsis: domain.searchType === "exact" || domain.searchType === "folder",
            icon: domain.icon,
            numOfResults: compareData?.[domain.url],
        };
    });

    useEffect(() => {
        if (!isDomainSelected()) {
            proNavigator.go(proNavigator.current().name, {
                ...proNavigator.getParams(),
                [domainQueryParamName]: pages[0].url,
            });
        }
    }, []);

    const onTabSelected = (index: number) => {
        onSelectSite(pages[index].url, tabs[index].numOfResults);
    };

    useEffect(() => {
        compareData && firstLoadCompareTab();
    }, [compareData]);

    useEffect(() => {
        setSelectedSiteDomain(page);
    }, [page]);

    useEffect(() => {
        pages && setSelectedTab(pages.findIndex((domain) => domain.url === selectedSiteDomain));
    }, [selectedSiteDomain]);

    const firstLoadCompareTab = () => {
        const firstLoad = sessionStorage.getItem(keyName);
        if (!firstLoad) {
            const result = pages.find((domain) => compareData[domain.url] && compareData[domain.url] !== 0);
            if (result) {
                sessionStorage.setItem(keyName, "true");
                void proNavigator.go(proNavigator.current().name, {
                    ...proNavigator.getParams(),
                    [domainQueryParamName]: result.url,
                });
            }
        }
    };

    return (
        <CompareTabs
            tabs={tabs}
            tabSelectedIndex={selectedTab}
            onTabSelectedCallback={onTabSelected}
            isLoading={isLoading}
            hideResults={hideResults}
        />
    );
};
